import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PromoBar from '../home/components/PromoBar';
import HeroSection from '../home/components/HeroSection';
import CategoryBanner from '../home/components/CategoryBanner';
import ProductGrid from '../home/components/ProductGrid';
import FullWidthBanner from '../home/components/FullWidthBanner';

export default function PumaPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PromoBar />
      <Header />
      <main className="flex-1">
        <HeroSection />
        <CategoryBanner />
        <ProductGrid />
        <FullWidthBanner />
      </main>
      <Footer />
    </div>
  );
}
